module.exports = __webpack_public_path__ + "img/header_icon2.a35f35e0.png";